import { AxiosPromise } from 'axios';

import { axios } from 'src/app/utils';
import { urlsConfig } from 'src/configs';
import { serviceLocals } from 'src/locals';
import { queryTypes, serviceIncidentFolderTypes } from 'src/types';
import { fileHelper, urlHelper } from '../helpers';

export const lookupIncidentFolder = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
  load,
  search,
}: serviceIncidentFolderTypes.IncidentFolderLookupDataType): AxiosPromise<serviceIncidentFolderTypes.IncidentFolderLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }
  if (search) {
    query.search = search.join(',');
  }
  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.incidentFolder.lookupIncidentFolder), {
    blockSpinner,
  });
};

export const lookupIncidentFolderWithEvent = ({
  limit,
  offset,
  ids,
  eventIds,
  value,
  order,
  sortOrder,
  blockSpinner,
  load,
  search,
}: serviceIncidentFolderTypes.IncidentFolderLookupDataType): AxiosPromise<serviceIncidentFolderTypes.IncidentFolderLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }
  if (search) {
    query.search = search.join(',');
  }
  if (value) {
    query.search = value;
  }
  if (eventIds) {
    return axios.get(`${urlsConfig.incidentFolder.lookupIncidentFolder}?eventIds=${eventIds}`, {
      blockErrorHandler: true,
    });
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.incidentFolder.lookupIncidentFolder), {
    blockSpinner,
  });
};

export const incidentFolderAdd = (
  form: serviceIncidentFolderTypes.IncidentFolderCreateDataType,
  // formData: FormData,
  options: { blockErrorHandler: boolean },
): AxiosPromise<serviceIncidentFolderTypes.IncidentFolderCreateResultType> => {
  const formData = fileHelper.convertDataURLsToFormData(form.attachments);

  if (form.eventId) {
    formData.append('eventId', form.eventId);
  }

  if (form.incidentFolderNumber) {
    formData.append('incidentFolderNumber', form.incidentFolderNumber);
  }

  if (form.incidentFolderName) {
    formData.append('incidentFolderName', form.incidentFolderName);
  }

  if (form.incidentFolderManagerId) {
    formData.append('incidentFolderManagerId', form.incidentFolderManagerId);
  }

  if (form.description) {
    formData.append('description', form.description);
  } else {
    formData.append('description', '');
  }

  if (form.log) {
    formData.append('log', form.log.join(','));
  }

  if (form.comment) {
    formData.append('comment', form.comment);
  } else {
    formData.append('comment', '');
  }

  return axios.post(urlsConfig.incidentFolder.incidentFolderAdd, formData, { headers: serviceLocals.formDataHeader });
};

export const incidentFolderEdit = (
  form: serviceIncidentFolderTypes.IncidentFolderEditDataType,
  deletedAttachments: string[],
  // formData: FormData,
): AxiosPromise<serviceIncidentFolderTypes.IncidentFolderEditDataType> => {
  const formData = fileHelper.convertDataURLsToFormData(form.attachments);

  if (form.id !== undefined) {
    formData.append('id', form.id);
  }

  if (deletedAttachments !== undefined) {
    deletedAttachments.forEach((eachAttachment: any) => {
      formData.append('deletedAttachments', eachAttachment);
    });
  }

  if (form.eventId) {
    formData.append('eventId', form.eventId);
  }

  if (form.incidentFolderNumber) {
    formData.append('incidentFolderNumber', form.incidentFolderNumber);
  }

  if (form.incidentFolderName) {
    formData.append('incidentFolderName', form.incidentFolderName);
  }

  if (form.incidentFolderManagerId) {
    formData.append('incidentFolderManagerId', form.incidentFolderManagerId);
  }

  if (form.description) {
    formData.append('description', form.description);
  } else {
    formData.append('description', '');
  }

  if (form.log) {
    formData.append('log', form.log.join(','));
  }

  if (form.comment) {
    formData.append('comment', form.comment);
  } else {
    formData.append('comment', '');
  }
  return axios.patch(urlsConfig.incidentFolder.incidentFolderdit, formData, { blockErrorHandler: true });
};

export const incidentFolderDelete = ({
  id,
}: serviceIncidentFolderTypes.IncidentFolderDeleteDataType): AxiosPromise<serviceIncidentFolderTypes.IncidentFolderDeleteResultType> => {
  return axios.delete(`${urlsConfig.incidentFolder.incidentFolderDelete}/${id}`);
};
